import {
  DvGridComponent,
  DvQuickFilterComponent,
  DvGridToolbarComponent,
  DvActionComponent,
} from '@devinco/ui/grid';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { pendingChangesGuard } from '@core/guards/pending-changes.guard';
import { userRolesAndPermissionsGuard } from '@core/guards/user-roles-and-permissions.guard';
import {
  DvDynamicFormModule,
  DvEditorsModule,
  DvNavTabsModule,
  DvSavePanelModule,
} from '@devinco/ui/legacy';
import { RolesAndPermissions } from '@shared/constants/roles-and-permissions';
import { TranslateModule } from '@ngx-translate/core';
import { DirectivesModule } from '@shared/directives/directives.module';
import { AgGridModule } from 'ag-grid-angular';
import { UserAccessControlTabComponent } from './components/user-access-control-tab/user-access-control-tab.component';
import { UserPermissionsGridComponent } from './components/user-access-control-tab/user-permissions-grid/user-permissions-grid.component';
import { UserRolesGridComponent } from './components/user-access-control-tab/user-roles-grid/user-roles-grid.component';
import { UserInformationTabComponent } from './components/user-information-tab/user-information-tab.component';
import { UsersGridComponent } from './components/users-grid/users-grid.component';
import { UsersTabsComponent } from './components/users-tabs/users-tabs.component';
import { UsersPageComponent } from './users-page.component';
import { PipesModule } from '@shared/pipes/pipes.module';
import { DvButtonComponent } from '@devinco/ui/dds';
import { UserPropertiesTabComponent } from './components/user-properties-tab/user-properties-tab.component';

import { DvVerticalSplitterComponent } from '@devinco/ui/dds/splitter';
import { UserDevicesTabComponent } from './components/user-devices-tab/user-devices-tab.component';

export const UserRouteName = {
  Main: 'users',
  Information: 'information',
  AccessControl: 'access-control',
  Properties: 'properties',
  Devices: 'devices',
};

const routes: Routes = [
  {
    path: '',
    component: UsersPageComponent,
    children: [
      {
        path: ':id',
        pathMatch: 'full',
        redirectTo: `:id/${UserRouteName.Information}`,
      },
      {
        path: ':id',
        component: UsersTabsComponent,
        children: [
          {
            path: UserRouteName.Information,
            component: UserInformationTabComponent,
            canDeactivate: [
              (component: UserInformationTabComponent) =>
                pendingChangesGuard(component),
            ],
          },
          {
            path: UserRouteName.AccessControl,
            component: UserAccessControlTabComponent,
            canActivate: [
              () =>
                userRolesAndPermissionsGuard([RolesAndPermissions.UserRead]),
            ],
          },
          {
            path: UserRouteName.Properties,
            component: UserPropertiesTabComponent,
          },
          {
            path: UserRouteName.Devices,
            component: UserDevicesTabComponent,
          },
        ],
      },
    ],
  },
];

@NgModule({
  declarations: [
    UsersPageComponent,
    UsersGridComponent,
    UserInformationTabComponent,
    UserAccessControlTabComponent,
    UserRolesGridComponent,
    UserPermissionsGridComponent,
  ],
  imports: [
    AgGridModule,
    DirectivesModule,
    DvButtonComponent,
    UsersTabsComponent,
    DvNavTabsModule,
    DvDynamicFormModule,
    DvSavePanelModule,
    PipesModule,
    CommonModule,
    RouterModule.forChild(routes),
    TranslateModule,
    DvEditorsModule,
    DvGridComponent,
    DvQuickFilterComponent,
    DvGridToolbarComponent,
    DvActionComponent,
    DvVerticalSplitterComponent,
  ],
})
export class UsersPageModule {}
